/* pdf label start */
// The theme rebuilds the drawer before emitting ajaxCart.afterCartLoad.
// Keep label refresh independent of cart totals, checkout and gift updates.
(function () {
  'use strict';
  if (window.dreamePdfLabelCartInitialized) return;
  window.dreamePdfLabelCartInitialized = true;

  var cachedData = null;
  var revision = 0;
  var pendingRequest = null;

  function parseData(markup) {
    var doc = new DOMParser().parseFromString(markup || '', 'text/html');
    var node = doc.querySelector('[data-pdf-label-cart-data]');
    return node ? JSON.parse(node.textContent) : null;
  }

  function validData(data) {
    return data && Array.isArray(data.cartHandles) && Array.isArray(data.handles)
      && typeof data.defaultMarkup === 'string' && typeof data.durabilityTitle === 'string'
      && data.productMarkupMap && typeof data.productMarkupMap === 'object'
      && !Array.isArray(data.productMarkupMap);
  }

  function resizeFooter() {
    if (window.theme && theme.cache && theme.cache.$drawerRight
        && typeof theme.sizeCartDrawerFooter === 'function') {
      theme.sizeCartDrawerFooter();
    }
  }

  function render(data, handles) {
    document.querySelectorAll('[data-pdf-label-cart]').forEach(function (container) {
      container.replaceChildren();
      if (validData(data)) {
        if (data.defaultMarkup && handles.some(function (handle) {
          return data.handles.indexOf(handle) !== -1;
        })) {
          var warranty = document.createElement('div');
          warranty.className = 'ajaxcart__pdf-entry ajaxcart__pdf-entry--default';
          warranty.innerHTML = data.defaultMarkup;
          container.appendChild(warranty);
        }

        var row = document.createElement('div');
        row.className = 'ajaxcart__pdf-entry-row';
        handles.forEach(function (handle) {
          var markup = Object.prototype.hasOwnProperty.call(data.productMarkupMap, handle)
            ? data.productMarkupMap[handle] : '';
          if (typeof markup !== 'string' || !markup) return;
          var entry = document.createElement('div');
          entry.className = 'ajaxcart__pdf-entry ajaxcart__pdf-entry--product';
          entry.innerHTML = markup;
          row.appendChild(entry);
        });
        if (row.childElementCount) {
          var group = document.createElement('div');
          group.className = 'ajaxcart__pdf-entry-group ajaxcart__pdf-entry-group--product';
          var title = document.createElement('p');
          title.className = 'ajaxcart__pdf-entry-title';
          title.textContent = data.durabilityTitle;
          group.append(title, row);
          container.appendChild(group);
        }
      }
      container.hidden = !container.childElementCount;
      container.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('load', resizeFooter, { once: true });
      });
    });
    // Recalculate after asynchronous labels change the existing fixed footer.
    window.requestAnimationFrame(resizeFooter);
  }

  function refresh(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var currentRevision = ++revision;
    if (pendingRequest) pendingRequest.abort();
    var handles = Array.from(new Set(cart.items.map(function (item) { return item.handle; })));
    // Remove deleted products immediately, even when the section request fails.
    render(cachedData, handles);
    if (!handles.length || !document.querySelector('[data-pdf-label-cart]')) return;

    var controller = new AbortController();
    pendingRequest = controller;
    var timer = window.setTimeout(function () { controller.abort(); }, 8000);
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    var url = root.replace(/\/?$/, '/') + '?sections=pdf-label-cart-data';
    fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('PDF label section unavailable');
        return response.json();
      })
      .then(function (sections) {
        var data = parseData(sections && sections['pdf-label-cart-data']);
        if (currentRevision !== revision || controller.signal.aborted || !validData(data)) return;
        // A response for a different cart must not restore removed labels.
        var returnedHandles = Array.from(new Set(data.cartHandles));
        if (returnedHandles.length !== handles.length || !handles.every(function (handle) {
          return returnedHandles.indexOf(handle) !== -1;
        })) return;
        cachedData = data;
        render(data, handles);
      })
      .catch(function () {
        // Auxiliary label failure leaves the current cart fully usable.
      })
      .finally(function () {
        window.clearTimeout(timer);
        if (pendingRequest === controller) pendingRequest = null;
      });
  }

  function init() {
    try {
      var initial = document.querySelector('[data-pdf-label-cart-data]');
      cachedData = initial ? JSON.parse(initial.textContent) : null;
    } catch (error) {
      cachedData = null;
    }
    if (window.jQuery) {
      window.jQuery(document.body).on('ajaxCart.afterCartLoad.pdfLabels', function (event, cart) {
        refresh(cart);
      });
    }
    if (validData(cachedData)) render(cachedData, cachedData.cartHandles);
  }

  // Deferred assets run after the DOM is parsed, before the theme's ready callbacks.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* pdf label end */
